export class IsophiException extends Error {
  public constructor(message?: string) {
    super(message);
    this.name = 'IsophiException';
  }
}
